define('modules/editor/models/variant',['require','exports','module','backbone','../collections/variant_contents','./content_page','./confirmation_page','./activeitemstate','base/reqres','env','lib/util','../../lp_integration/models/integration_correodirect','common/jquery/config','../collections/form_collection','../behaviours/has_property_groups'],function (require, exports, module) {
  "use strict";
  var Backbone = require("backbone"),
      ContentCollection = require("../collections/variant_contents"),
      ContentModel = require("./content_page"),
      ConfirmationModel = require("./confirmation_page"),
      ActiveItemState = require("./activeitemstate"),
      ReqRes = require("base/reqres"),
      config = require("env"),
      util = require("lib/util"),
      CorreoDirectModel = require("../../lp_integration/models/integration_correodirect"),
      jQueryConfig = require("common/jquery/config");

  var FormCollection = require("../collections/form_collection");

  function backwardsCompatLayer(data) {
    var content = data.content || {json: {}},
        confirmation = data.confirmation || {json: {}};
    data.content = [content, confirmation];
  }

  function metaCompatLayer(data) {
    function get(name, data) {
      var index = name === "content" ? 0 : data.content.length - 1;
      return data.content[index];
    }

    _.each(["content", "confirmation"], function (name) {
      var model = get(name, data),
          meta = data.meta && data.meta[name];
      if (!meta) return;
      model.json.styles = meta.styles || [];
      model.json.scripts = meta.scripts || [];
      if (meta && _.isObject(meta.seo)) {
        model.json.seo = meta.seo;
      }
    });
  }

  var Serialization = {
    parse: function (data, options) {
      if (options.saved) {
        //avoid re-generating collections after save
        return;
      }
      this.setDefaultProperties(data.platform || "desktop");
      // check if the variant is new
      this.isEmpty = _.reduce(data.content, function (isEmpty, step) {
        return !step.html || isEmpty;
      }, false);

      if (!(data.content instanceof Array)) {
        backwardsCompatLayer(data);
      } else if (!data.content.length) {
        data.content = null;
        backwardsCompatLayer(data);
      }
      metaCompatLayer(data);
      this.content.reset(data.content, {parse: true});


      // it remains confirmation
      /*if(this.getContent().seoParameters.get("title") === ""){
        this.getContent().seoParameters.set("title", data.name);
      }*/

      if (data.meta && data.meta.properties) {
        //backwards compatibility for page:conversion
        //if (!_.findWhere(data.meta.properties, { name: "page:conversion" })) data.meta.properties.push({ name: "page:conversion", active: false });
        //set every property group sent through ctor/init
        _.each(data.meta.properties, function (pg) {
          var myPg = this.getPropertyGroup(pg.name);
          if (myPg && myPg.attributes) {
            myPg.set(_.omit(pg, "name"));
          }
        }, this);
      }
      var variantJson = _.omit(data, ["content", "confirmation", "meta", "history", "stats"]);
      return module.exports.__super__.parse.call(this, variantJson);
    },
    parseMeta: function (meta) {
    },
    toJSON: function () {
      var data = module.exports.__super__.toJSON.apply(this);
      delete data.stats;
      delete data.history;
      // avoid to reset statistics
      delete data.visitors;
      delete data.visits;
      delete data.conversion;
      _.extend(data, {
        content: this.content.toJSON(),
        meta: {
          properties: _.invoke(this.propertyGroups, "toJSON")
        }
      });
      return data;
    }
  };

  module.exports = Backbone.Model.extend({
    defaultPropertyGroups: [],
    propertyGroups: [
      {
        name: "page:defaults",
        defaults: {
          width: 1024,
          marginTop: 0,
          backgroundColor: "#ffffff",
          color: "#000000",
          linkColor: "#0000ff",
          language: "es",
          fontFamily: "Arial"
        }
      },
      {
        name: "page:popup",
        defaults: {
          title: 'Popup',
          width: '480',
          height: '240',
          windowPosition: 'center center',
          windowRadius: 5,

          closeOnClickOutside: true,
          useOverlay: true,
          overlayOpacity: 5,
          overlayColor: '#000000',
          shadowColor: '#000000',

          fontFamily: 'Arial',
          backgroundColor: '#ffffff',
          fontColor: '#000000',
          linkColor: '#0000ff'
        }
      },
      {
        name: "page:confirmation",
        defaults: {
          confirmationUrl: "",
          sendParams: false
        }
      },
      {
        name: "page:privacy",
        defaults: {}
      },
      {
        name: "page:notification",
        defaults: {}
      },
      {
        name: "page:conversion",
        defaults: {
          skip: false,
          conditionalExec: false,
          reqConversion: "",
          successMessage: "",
          executionStep: 0
        }
      },
      {
        name: "page:gtm",
        defaults: {
          gtmId: ""
        }
      },
      {
        name: "page:jquery_selector",
        defaults: {
          version: jQueryConfig.getLatest().version,
          url: jQueryConfig.getLatest().url,
          successMessage: ""
        }
      }
    ],
    desktopDefaults: {
      width: 1024
    },
    mobileDefaults: {
      width: 320
    },
    name: "variant",

    url: function () {
      var baseUrl = config.apiHost + "/pages/" + this.get("pages_id") + "/variants/";
      baseUrl += this.id || "main";
      return baseUrl;
    },

    constructor: function () {
      this.activeItemState = new ActiveItemState();
      this.services = new ReqRes();
      this.content = new ContentCollection({services: this.services, variant: this}); //new ContentModel({}, {activeItemState: this.activeItemState});
      //this.confirmation = new ConfirmationModel({}, {activeItemState: this.activeItemState});
      /*this.content.services = this.services;
      this.confirmation.services = this.services;
      //put a reference to this model in the child ones
      this.content.variant = this;
      this.confirmation.variant = this;*/
      module.exports.__super__.constructor.apply(this, arguments);
    },

    initialize: function (attrs, options) {
      //this is needed because collection.fetch calls parse before
      //initialize, so the propertyGroups were not ready
      if (attrs && attrs.meta && attrs.meta.properties) {
        //set every property group sent through ctor/init
        _.each(attrs.meta.properties, function (pg) {
          var propertyGroup = this.getPropertyGroup(pg.name);
          propertyGroup && propertyGroup.set(_.omit(pg, "name"), {silent: true});
        }, this);
      }

      this.addEventListeners();
    },

    getContent: function () {
      return this.content.getContent();
    },

    getConfirmation: function () {
      return this.content.getConfirmation();
    },

    isConfirmationStep: function (step) {
      return this.content.length - 1 === step;
    },

    getStepType: function (step) {
      if (step < 1) {
        return false;
      }

      return this.getContentForStep(step).get('role');
    },

    /** helper method to help generate automatic ids **/
    getElementCount: function () {
      return this.content.reduce(function (count, step) {
        return count + step.sections.length + step.sections.reduce(function (n, section) {
          return n + section.getElementCount();
        }, 0);
      }, 0);
    },

    getHighestId: function () {
      return Math.max.apply(Math, this.content.invoke("getHighestId"));
    },

    getElementById: function (id) {
      return _.compact(this.content.invoke("getElementById", id))[0];
    },

    getSectionById: function (id) {
      return this.content.reduce(function (acc, step) {
        return acc || step.sections.reduce(function (acc, section) {
          if (section.getPropertyGroup('idclass').get('id') === id) acc = section;
          return acc;
        }, undefined);
      }, undefined);
    },

    getFBAppId: function () {
      return this.content.reduce(function (acc, step) {
        return acc || step.sections.reduce(function (acc, section) {
          return acc || section.getFBAppId();
        }, undefined);
      }, undefined);
    },

    getLinkedInAppId: function () {
      return this.content.reduce(function (acc, step) {
        return acc || step.sections.reduce(function (acc, section) {
          return acc || section.getLinkedInAppId();
        }, undefined);
      }, undefined);
    },

    getGoogleReCaptchaURL: function () {
      return this.content.reduce(function (acc, step) {
        return acc || step.sections.reduce(function (acc, section) {
          return acc || section.getGoogleReCaptchaURL();
        }, undefined);
      }, undefined);
    },

    getGoogleReCaptchaSiteKey: function () {
      return this.content.reduce(function (acc, step) {
        return acc || step.sections.reduce(function (acc, section) {
          return acc || section.getGoogleReCaptchaSiteKey();
        }, undefined);
      }, undefined);
    },

    hasIBAN: function () {
      return this.content.reduce(function (acc, step) {
        return acc || step.sections.reduce(function (acc, section) {
          return acc || section.hasIBAN();
        }, undefined);
      }, undefined);
    },

    getExternalLibs: function () {
      var libs = [];
      if (this.hasIBAN()) libs.push("iban");
      return libs;
    },

    getCorreoDirect: function () {
      return this.content.reduce(function (model, step) {
        var form = step.hasElement("element:form");
        if (form) {
          var integration = form.getPropertyGroup("form:integration:correodirect");

          var fields = _.extend(model.get("fields"), integration.get("fields"));
          model.set("fields", fields);

          var idaf = model.get("idaf");
          model.set("idaf", integration.get("idaf") || idaf);
          model.set("active", integration.get("active"));
        }
        return model;
      }, new CorreoDirectModel({id: "correodirect", fields: {dummy: ""}}, {pageId: this.get("pages_id")}));
    },

    setCorreoDirect: function (model) {
      var idaf = model.get("idaf"),
          active = model.get("active"),
          fields = model.get("fields");
      this.content.forEach(function (step) {
        var form = step.hasElement("element:form");
        if (form) {
          var integration = form.getPropertyGroup("form:integration:correodirect"),
              fieldNames = form.getIntegrableFields();
          integration.set("fields", _.pick(fields, fieldNames));
          integration.set("idaf", idaf);
          integration.set("active", active);
        }
      });
    },

    getFormFields: function () {
      return this.content.reduce(function (formCollection, step) {
        var form = step.hasElement("element:form");
        if (form) formCollection.addForm(form);
        return formCollection;
      }, new FormCollection());
    },

    addEventListeners: function () {
      this.listenTo(this.content, "form:added", function (model) {
        model.set("variantId", this.id);
      });

      this.listenTo(this.getPropertyGroup("page:defaults"), "change", function (model) {
        this.trigger("change:page:defaults", model);
      });

      this.listenTo(this.getPropertyGroup("page:popup"), "change", function (model) {
        this.trigger("change:page:popup", model);
      });

      this.listenTo(this.getPropertyGroup("page:confirmation"), "change", function (model) {
        this.trigger("change:page:confirmation", model);
      });

      this.listenTo(this.getPropertyGroup("page:privacy"), "change", function (model) {
        this.trigger("change:page:privacy", model);
      });

      this.listenTo(this.getPropertyGroup("page:notification"), "change", function (model) {
        this.trigger("change:page:notification", model);
      });

      this.listenTo(this.getPropertyGroup("page:conversion"), "change", function (model) {
        this.trigger("change:page:conversion", model);
      });

      this.listenTo(this.getPropertyGroup("page:conversion"), "change:executionStep", function (model, executionStep) {
        this.content.invoke("setupFormConversion");
      });

      this.listenTo(this.getPropertyGroup("page:gtm"), "change", function (model) {
        this.trigger("change:page:gtm", model);
      });

      this.listenTo(this.getPropertyGroup("page:jquery_selector"), "change", function (model) {
        this.trigger("change:page:jquery_selector", model);
      });
    },

    getContentFor: function (target) {
      return (target === "content" ? this.content.getContent() : this.content.getConfirmation());
    },

    getContentForStep: function (step) {
      if (step < 0) step = 0;
      return this.content.getStep(step);
    },

    setContentHtml: function (html) {
      this.getContent().set("html", html);
    },

    setConfirmationHtml: function (html) {
      this.getConfirmation().set("html", html);
    },

    setStepHtml: function (html, step) {
      var model = this.content.getStep(step);
      model.set("html", html);
    },

    unsetWeight: function () {
      this.unset('weight');
    },

    setDefaultProperties: function (platform) {
      var platformSettings = platform === "desktop" ? this.desktopDefaults : this.mobileDefaults,
          pageDefaults = this.getPropertyGroup("page:defaults");

      if (pageDefaults && _.isFunction(pageDefaults.set)) {
        pageDefaults.set(platformSettings);
      }
    },

    adjustPageWidth: function (incWidth) {
      var pageDefaults = this.getPropertyGroup("page:defaults"),
          currentWidth = parseInt(pageDefaults.get("width"));

      pageDefaults.set("width", parseInt(currentWidth + incWidth));
      //propagate to each section!
      this.content.invoke("adjustSectionWidth", incWidth);
    },

    parse: Serialization.parse,

    toJSON: Serialization.toJSON
  });

  util.mixin(module.exports, require("../behaviours/has_property_groups"));
  //util.mixin(module.exports, require("../behaviours/history"));
});

